module.exports = __webpack_public_path__ + "static/Canela-Medium-8eb893e33c8ca8255d5bbf90e5e630c1.otf";